import cz from './cz.json';
import sk from './sk.json';

const translations = process.env.REACT_APP_LANG === 'sk' ? sk : cz;

export function t(key) {
    return translations[key] || key;
}
